<app-site-header />
<main class="search-page">
  <section class="search-hero">
    <div class="kota-container search-hero__inner">
      <h1 class="search-hero__title">¿Qué estás buscando?</h1>
      <p class="search-hero__subtitle">Encuentra el mueble perfecto para transformar tu espacio</p>

      <form class="search-bar" (ngSubmit)="applySearch()" novalidate>
        <span class="search-bar__icon" aria-hidden="true">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.3-4.3" />
          </svg>
        </span>
        <input
          type="search"
          name="q"
          class="search-bar__input"
          placeholder="Buscar recámaras, muebles..."
          [ngModel]="searchInput()"
          (ngModelChange)="searchInput.set($event)"
          autocomplete="off"
        />
        <button type="submit" class="search-bar__btn">
          Buscar
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </button>
      </form>

      <div class="search-popular">
        <span class="search-popular__label">Populares:</span>
        @for (tag of popularTags; track tag.label) {
          <button type="button" class="search-popular__tag" (click)="applyTag(tag.query)">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
              <polyline points="16 7 22 7 22 13" />
            </svg>
            {{ tag.label }}
          </button>
        }
      </div>
    </div>
  </section>

  <section class="search-categories">
    <div class="kota-container">
      <div class="search-categories__head">
        <div>
          <h2 class="search-categories__title">Explora por Categoría</h2>
          <p class="search-categories__subtitle">Encuentra exactamente lo que necesitas</p>
        </div>
        <a routerLink="/catalogo" class="search-categories__all">
          Ver todas
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </a>
      </div>

      <div class="search-categories__grid kota-enter-stagger">
        @for (c of categoryCards; track c.title) {
          <a [routerLink]="['/catalogo']" [queryParams]="{ categoria: c.filter }" class="search-cat-card">
            <div class="search-cat-card__img-wrap">
              <img [src]="c.image" [alt]="c.title" width="400" height="200" loading="lazy" />
            </div>
            <div class="search-cat-card__body">
              <h3 class="search-cat-card__name">{{ c.title }}</h3>
              <p class="search-cat-card__count">{{ c.count }}</p>
            </div>
          </a>
        }
      </div>
    </div>
  </section>

  <section class="search-results">
    <div class="kota-container">
      <div class="search-results__head">
        <div class="search-results__title-row">
          <h2 class="search-results__title">Resultados Sugeridos</h2>
          <span class="search-results__badge">{{ resultCount() }} productos</span>
        </div>
        <div class="search-results__tools">
          <label class="search-results__sort-wrap">
            <span class="visually-hidden">Ordenar por</span>
            <select class="search-results__sort" [value]="sort()" (change)="onSortChange($any($event.target).value)">
              <option value="popular">Ordenar por: Más populares</option>
              <option value="priceAsc">Precio: menor a mayor</option>
              <option value="priceDesc">Precio: mayor a menor</option>
            </select>
          </label>
          <button type="button" class="search-results__filter" (click)="noop($event)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <line x1="4" x2="4" y1="21" y2="14" />
              <line x1="4" x2="4" y1="10" y2="3" />
              <line x1="12" x2="12" y1="21" y2="12" />
              <line x1="12" x2="12" y1="8" y2="3" />
              <line x1="20" x2="20" y1="21" y2="16" />
              <line x1="20" x2="20" y1="12" y2="3" />
              <line x1="2" x2="6" y1="14" y2="14" />
              <line x1="10" x2="14" y1="8" y2="8" />
              <line x1="18" x2="22" y1="16" y2="16" />
            </svg>
            Filtros
          </button>
        </div>
      </div>

      @if (filtered().length === 0) {
        <p class="search-results__empty">No hay productos que coincidan con tu búsqueda.</p>
      } @else {
        <div class="search-results__grid kota-enter-stagger">
          @for (p of filtered(); track p.id) {
            <a [routerLink]="['/producto', p.slug]" class="search-prod">
              <div class="search-prod__img-wrap">
                <img [src]="p.image" [alt]="p.name" width="280" height="280" loading="lazy" />
                @if (p.tag) {
                  @if (p.tag.kind === 'nuevo') {
                    <span class="search-prod__badge">Nuevo</span>
                  }
                  @if (p.tag.kind === 'sale') {
                    <span class="search-prod__badge search-prod__badge--sale">{{ p.tag.text }}</span>
                  }
                }
              </div>
              <div class="search-prod__info">
                <h3 class="search-prod__name">{{ p.name }}</h3>
                <p class="search-prod__desc">{{ p.category === 'recamaras' ? 'Recámara y complementos' : 'Calidad KOTA' }}</p>
                <div class="search-prod__prices">
                  <span class="search-prod__price">{{ p.price }}</span>
                  @if (p.oldPrice) {
                    <span class="search-prod__old">{{ p.oldPrice }}</span>
                  }
                </div>
              </div>
            </a>
          }
        </div>
      }
    </div>
  </section>
</main>
